<div class="row">
  <div class="col-sm-1">
    <mat-checkbox [formControl]="control"></mat-checkbox>
  </div>
  <div class="col-sm-11">
    <span [innerHTML]="text"></span>
  </div>
</div>